export const DEFAULT_ACCENT = '#FB5524';
export const DEFAULT_ACCENT_RGB = [251, 85, 36];

export const STATUS_STYLES = {
  open: { dot: '#F15A22', badge: 'bg-[#FDEAD9] text-[#C2410C]' },
  pending: { dot: '#2563EB', badge: 'bg-[#E6EDFD] text-[#1D4ED8]' },
  snoozed: { dot: '#2563EB', badge: 'bg-[#E6EDFD] text-[#1D4ED8]' },
  resolved: { dot: '#22A55A', badge: 'bg-[#E4F4E9] text-[#15803D]' },
};

export const DEFAULT_STATUS_STYLE = {
  dot: '#94A3B8',
  badge: 'bg-[#EDEFF2] text-[#5B6472]',
};

export const PRIORITY_COLORS = {
  urgent: '#d4452a',
  high: '#d4452a',
  medium: '#d97706',
  low: '#94a3b8',
};

export const statusStyle = value =>
  STATUS_STYLES[value] || DEFAULT_STATUS_STYLE;
